function mentionVariantsInclude(variants, variant) {
    return variants === undefined || variants.includes(variant);
}
export function getMentionMenuInclusionPolicy({ variants, isComputerMode, forceSkillsEnabled, }) {
    const isSearchModeOnlySlashMenuEnabled = !forceSkillsEnabled;
    const includeSearchModes = isSearchModeOnlySlashMenuEnabled || mentionVariantsInclude(variants, 'search-mode');
    const basePolicy = {
        includeTabs: mentionVariantsInclude(variants, 'tab'),
        includeSpaces: mentionVariantsInclude(variants, 'space'),
        includeSources: mentionVariantsInclude(variants, 'sources'),
        includeSearchModes,
        // Device mentions only influence routing on the Computer/ASI path, so the
        // picker section is limited to Computer mode and Computer-native surfaces.
        includeDevices: mentionVariantsInclude(variants, 'device') && (isComputerMode || forceSkillsEnabled),
        includeUsers: mentionVariantsInclude(variants, 'user'),
    };
    if (isSearchModeOnlySlashMenuEnabled) {
        return {
            ...basePolicy,
            includeSkills: false,
        };
    }
    return {
        ...basePolicy,
        includeSkills: true,
    };
}
//# sourceMappingURL=getMentionMenuInclusionPolicy.js.map